import Picker from '../picker'
import DatePickerPanel from '../panel/Date/date'
import RangeDatePickerPanel from '../panel/Date/date-range'
import { oneOf } from '../../../../utils/assist'

export default {
    name: 'YYDatePicker',
    mixins: [Picker],
    props: {
        type: {
            validator(value) {
                return oneOf(value, ['year', 'month', 'week', 'date', 'daterange', 'datetime', 'datetimerange'])
            },
            default: 'date'
        },
        endDayIsLastDay: {
            type: Boolean,
            default: false
        },
        dbweek: {
            type: Boolean,
            default: false
        }
    },
    provide () {
        return {
            datePickerRoot: this
        }
    },
    components: {
        DatePickerPanel,
        RangeDatePickerPanel
    },
    computed: {
        panel() {
            const isRange = this.type === 'daterange' || this.type === 'datetimerange'
            return isRange ? 'RangeDatePickerPanel' : 'DatePickerPanel'
        },
        ownPickerProps() {
            return this.options
        }
    }
}